"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Validator = void 0;

var _Eloquent = require("../utils/Eloquent");

var _Helper = require("../utils/Helper");

var definedRules = _interopRequireWildcard(require("../utils/Rules"));

var _Console = require("../utils/Console");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Validator =
/*#__PURE__*/
function () {
  function Validator(componentInstance) {
    _classCallCheck(this, Validator);

    _defineProperty(this, "componentInstance", void 0);

    _defineProperty(this, "rules", void 0);

    _defineProperty(this, "errorsBag", void 0);

    _defineProperty(this, "isValid", void 0);

    _defineProperty(this, "availableRules", void 0);

    _defineProperty(this, "rulesWithModelRelatedArguments", void 0);

    _defineProperty(this, "messages", void 0);

    _defineProperty(this, "customMessages", void 0);

    this.componentInstance = componentInstance;
    this.rules = null;
    this.errorsBag = [];
    this.isValid = true;
    this.availableRules = ['required', 'integer', 'email', 'min', 'max', 'string', 'required_if', 'date', 'before_or_equal', 'after_or_equal', 'credit_card_number', 'credit_card_cvv', 'credit_card_month', 'credit_card_year', 'length'];
    this.rulesWithModelRelatedArguments = ['before_or_equal', 'after_or_equal', 'required_if', 'credit_card_number', 'credit_card_cvv', 'length'];
    this.messages = this.getDefaultErrorMessages();
    this.customMessages = {};
  }

  _createClass(Validator, [{
    key: "setRules",
    value: function setRules(_rules) {
      // TODO: validate the rules api is correct
      this.rules = _rules;
      return this;
    }
  }, {
    key: "setCustomMessages",
    value: function setCustomMessages(_customMessages) {
      (0, _Console.warnIf)(_typeof(_customMessages) !== 'object', 'The validator customMessages must be an object');
      this.customMessages = _customMessages;
      return this;
    }
  }, {
    key: "getRules",
    value: function getRules() {
      return this.rules;
    }
  }, {
    key: "getData",
    value: function getData() {
      var _data = this.componentInstance.$data;
      var result = {};
      Object.keys(_data).forEach(function (key) {
        if (key !== 'validator') result[key] = _data[key];
      });
      return result;
    }
  }, {
    key: "getDefaultErrorMessages",
    value: function getDefaultErrorMessages() {
      return {
        required: 'This field is required',
        integer: 'This field must be a number',
        email: 'This field must be a valid email',
        min: 'This field must not be less than {arg}',
        max: 'This field must not be greater than {arg}',
        string: 'This field must be characters',
        required_if: 'This field is required',
        date: 'This field must be a valid date',
        before_or_equal: 'This date must be before or equal to {arg}',
        after_or_equal: 'This date must be after or equal to {arg}',
        credit_card_number: 'The card number is invalid',
        credit_card_cvv: 'The card cvv is invalid',
        credit_card_month: 'The card month is invalid',
        credit_card_year: 'The card year is invalid',
        length: 'The length should be {arg}'
      };
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this = this;

      var validationRules = this.getRules();
      this.errorsBag = [];
      this.isValid = true;
      (0, _Console.warnIf)(!validationRules, 'You must specify the validation rules.');
      validationRules.forEach(function (item) {
        var modelName = item.model;
        var modelValue = (0, _Eloquent.find)(_this.getData(), modelName);
        var rules = item.rules.split('|'); // if the rules contains 'required_if' rule, ignore the other rules unless the 'required_if' condition is matched

        if (_this.shouldIgnoreRequiredIfRules(rules)) return; // execute the rules

        rules.forEach(function (_rule) {
          _this.executeRule(_rule, modelName, modelValue);
        });
      }); // update the error bag inside the validator of the vue component instance

      if (_typeof(this.componentInstance) === 'object' && this.componentInstance.$data) {
        this.componentInstance.$data.validator.errorsBag = this.errorsBag;
      }

      return this;
    }
  }, {
    key: "renderError",
    value: function renderError(model) {
      if (!this.errorsBag.length) return null;
      var errors = this.errorsBag.filter(function (error) {
        return error.model === model;
      });
      return errors.length ? errors[0].message : null;
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage(model, rule, arg) {
      var key = model + '.' + rule;
      var message = null; // get custom error message if exists

      if (this.customMessages.hasOwnProperty(key)) {
        message = this.customMessages[key];
      } else {
        message = this.messages[rule];
      }

      return message.replace('{arg}', arg);
    }
  }, {
    key: "addError",
    value: function addError(model, rule, errorMessage) {
      var key = model + '.' + rule;
      this.errorsBag.push({
        key: key,
        model: model,
        message: errorMessage
      });
    }
  }, {
    key: "shouldIgnoreRequiredIfRules",
    value: function shouldIgnoreRequiredIfRules(rules) {
      var hasRequiredIfRule = false;
      var requiredIfRule = null;
      rules.map(function (rule, key) {
        if (rule.startsWith("required_if:")) {
          hasRequiredIfRule = true;
          requiredIfRule = rule;
        }
      });

      if (hasRequiredIfRule) {
        var str = requiredIfRule.split(':');
        var arg = (0, _Eloquent.find)(this.getData(), str[1].trim());
        if (!arg) return true;
      }

      return false;
    }
  }, {
    key: "executeRule",
    value: function executeRule(_rule, modelName, modelValue) {
      var rule = _rule.trim();

      var arg = null;

      if ((0, _Helper.hasArg)(rule)) {
        var str = rule.split(':');
        rule = str[0].trim();
        arg = str[1].trim(); // check rules which their argument is related to another model

        if (this.rulesWithModelRelatedArguments.includes(rule)) {
          arg = (0, _Eloquent.find)(this.getData(), arg);
        }
      } // if a rule is not in the available rule, ignore it.


      if (!this.availableRules.includes(rule)) {
        (0, _Console.warn)('The rule ' + rule + ' for the model ' + modelName + ' is not defined. it will be ignored.');
        return true;
      } // get the rule error message


      var errorMessage = this.getErrorMessage(modelName, rule, arg); // call the rule method with the model value & update the error bag

      if (!definedRules[rule](modelValue, arg)) {
        this.addError(modelName, rule, errorMessage);
        this.isValid = false;
        return false;
      }

      return true;
    }
  }, {
    key: "passes",
    value: function passes() {
      return !!this.isValid;
    }
  }, {
    key: "fails",
    value: function fails() {
      return !!!this.isValid;
    }
  }, {
    key: "extend",
    value: function extend(ruleName, func, message) {
      var validApi = (0, _Console.warnIf)(!ruleName, 'Please specify a rule name as first argument for the validator extend() method') && (0, _Console.warnIf)(!func, 'Please specify a function as second argument for the validator extend() method') && (0, _Console.warnIf)(!message, 'Please specify a message as third argument for the validator extend() method') && (0, _Console.warnIf)(typeof ruleName !== 'string', 'The first argument must be a string in the validator extend() method') && (0, _Console.warnIf)(typeof func !== 'function', 'The second argument must be a function in the validator extend() method') && (0, _Console.warnIf)(typeof message !== 'string', 'The third argument must be a string in the validator extend() method') && (0, _Console.warnIf)(definedRules.hasOwnProperty(ruleName), 'The rule already exists!');
      if (!validApi) return;
      definedRules[ruleName] = func;
      this.availableRules.push(ruleName);
      this.messages[ruleName] = message;
    }
  }]);

  return Validator;
}();

exports.Validator = Validator;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@primitivesocial/ps-validation/dist/Classes/Validator.js
// module id = rLKD
// module chunks = 0 1